module.exports = {
  // Files in `static/remote` should be all included to prevent build from failing.
  // Add empty ones as placeholders even if partner will not use them.
  loaderBackgroundColor: '#3B058E',
  notificationDomain: 'Casumo',
  smallLogo: true, // Place file under 'static/remote/small-logo.svg'
  bigLogo: true, // Place file under 'static/remote/big-logo.svg'
  introVideo: false, // Place file under 'static/remote/intro.mp4'
  moduleBackgroundVideo: false, // Place file under 'static/remote/bg-video.mp4'
  moduleBackgroundImage: false // Place file under 'static/remote/bg-image.jpg'
}



// WEBPACK FOOTER //
// ./src/partners/config/remote.js